import { Field, Form } from 'formik';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 370px;
  margin-top: 165px;

  h1 {
    color: ${({ theme }) => theme.colors.blue};
    font-size: 1.4375rem;
    font-weight: bold;
    text-align: left;
    line-height: 18px;
    margin-bottom: 12px;
  }

  h2 {
    color: #5E5E5E;
    font-size: 0.9375rem;
    text-align: left;
    line-height: 26px;
    margin-bottom: 22px;
  }

  a {
    text-decoration: none;
  }

  @media (max-width: 768px) {
    margin-top: 65px;
    min-height: calc(100vh - 356px);
  }
`;

export const Label = styled.span`
  color: #5E5E5E;
  svg {
    margin-left: -5px;
    margin-right: 4px;
  }
  margin-bottom: 22px;
`;

export const FormContainer = styled(Form)`
  width: 100%;
`;

export const SelectTypeContainer = styled.div`
  display: flex;
  justify-content: space-between;

  button:first-child {
    margin-right: 23px;
  }

  input[type="radio"]:checked + label {
    color: white;
    background-color: #288EFD;
    border: 1px solid  #288EFD;
  }
`;

export const ButtonSelect = styled.label`
  display: flex;
  flex-direction: row;
  place-items: center;

  border-radius: 3px;
  padding: 13px;

  text-align: center;
  font-size: 0.75rem;
  font-weight: 400;
  color: #9A9A9A;

  width: 173px;
  height: 40px;

  border: 1px solid #9A9A9A;

  div {
    display: flex;
    flex: 1;
    place-content: center;
    align-items: center;
  }

  cursor: pointer;
`;

export const Selector = styled(Field)`
  display: none;
  height: 0;
  width: 0;
  cursor: pointer;
`;

export const InputsContainer = styled.div`
  width: 100%;
  margin-bottom: 30px;
`;

export const ButtonsContainer = styled.div`
  width: 100%;

  button {
    margin-bottom: 20px;
  }
`;

export const Tooltip = styled.label`
  position: relative;
  margin-top: 15px;
  color: ${({ theme }) => theme.colors.darkBlue};
  display: flex;
  align-items: center;
  font-weight: 400;
  justify-content: flex-end;

  div {
    cursor: pointer;
    display: flex;
    place-items: center;
  }

  button {
    margin-left: 12px;
    color: white;
    background-color: #F0B01B;
    border: none;
    border-radius: 100%;
    height: 15px;
    width: 15px;

    font-size: 11px;
    font-weight: bold;
    display: flex;
    place-content: center;
    outline: none;
  }

  #question {
    background-color: white;
    color: #363636;
    border-radius: 5px;
    font-size: 12px;
    opacity: 1;
    max-width: 382px;
    border: 1px solid #CFCFCF
  }

  .__react_component_tooltip.type-dark.place-top:after {
    border-top-color: #CFCFCF !important;
  }
`;


export const HeaderForm = styled.div`
  display: flex;
  flex-direction: column;
  height: 90px;
`;


export const CondoContainer = styled.section`
  border-radius: 5px;
  border: 1px solid #C8C8C8;
  padding: 16px 23px 16px 23px;
  background-color: #F5F5F5;
  display: flex;
  flex-direction: column;
  position: relative;

  margin-top: 11px;
  margin-bottom: 30px;

  p {
    font-size: 0.875rem;
    color: 14px;
    font-weight: 400;
    line-height: 17px;
    margin: 0;
    margin-bottom: 14px;
  }

  div:first-child {
    margin-bottom: 17px;
  }

  div {
    display: flex;
    flex-direction: row;

    input {
      margin-right: 17px;
    }

    label {
      font-size: 0.8125rem;
      color: #4D565C;
      line-height: 16px;
      font-weight: 400;

      strong {
        font-weight: bold;
      }
    }
  }
`;

export const CondoIcon = styled.div`
  height: 57px;
  width: 57px;
  border-radius: 50%;
  background-color: #F2F2F2;
  color: #4D565C;
  display: flex;
  place-content: center;
  place-items: center;
`;


export const CondoSelectedContainer = styled.div`
  border-radius: 5px;
  border: 1px solid #E2E2E2;
  box-shadow: #00000029 0px 3px 6px;
  background-color: white;
  position: relative;

  height: 100%;
  width: 100%;
  min-height: 125px;
  max-width: 370px;

  margin-top: 46px;
  margin-bottom: 20px;

  display: flex;
  flex-direction: column;
  place-items: center;
  place-content: center;

  h1 {
    color: black;
    font-size: 1rem;
    font-weight: bold;
    margin: 0;
    margin-bottom: 7px;
    margin-top: 45px;
    line-height: 19px;
    text-align: center;
    max-width: 226px;
  }

  h2 {
    font-size: 0.8125rem;
    margin: 0;
    text-align: center;
    margin: 0;
    line-height: 15px;
    max-width: 226px;
    margin-bottom: 24px;
  }

  ${CondoIcon} {
    top: -28px;
    position: absolute;
  }
`;

export const FieldSelect = styled.div`
  display: flex;
  flex-direction: column;

  div {
    display: flex;
    background: white;
    border-radius: 5px;
    border: 1px solid ${({ theme }) => theme.colors.lightGray};
    width: 100%;
    color: ${({ theme }) => theme.colors.gray};
    padding: 8px 12px 8px 12px;
    height: 50px;

    select {
      display: flex;
      width: 100%;
      flex: 1;
      background: transparent;
      border: 0;
      color: ${({ theme }) => theme.colors.gray};
      outline: none !important;
      padding: 0;

      &::placeholder {
        color: #666360;
      }
    }

    &:first {
      margin-bottom: 20px;
    }
  }
`;

export const SelectCondoConatoner = styled.section`
  display: flex;
  flex-direction: column;
  margin-bottom: 26px;

  div:nth-child(2) {
    margin-bottom: 20px;
  }
`;

export const ModalContainer = styled.div`
  padding: 28px 28px 39px 28px;
  max-width: 648px;
  width: 648px;

  @media (max-width: 768px) {
    padding: 18px;
    width: 100%;
  }
`;

export const ModalHeader = styled.header`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;

  h1 {
    color: ${({ theme }) => theme.colors.darkBlue};
    font-size: 20px;
    margin: 0;
    line-height: 24px;
    margin-top: 22.72px;
  }

  div {
    display: flex;
    place-content: space-between;

    h2 {
      margin: 0;
      color: #808495;
      font-size: 18px;
      font-weight: 400;
    }
  }

  svg {
    color: ${({ theme }) => theme.colors.darkBlue};
    cursor: pointer;
  }
`

export const ModalBody = styled.div`
  background-color: white;
  box-shadow: #00000029 0px 3px 6px;
  border: 1px solid #E2E2E2;
  border-radius: 5px;
  padding: 18px 16px 18px 16px;

  display: grid;
  grid-template-columns: auto auto;
  column-gap: 17px;

  margin-bottom: 20px;

  div {
    p {
      font-size: 0.8125rem;
      font-weight: 400;
      line-height: 15px;
      margin:0 ;
      margin-bottom: 31px;

      @media (max-width: 768px) {
          text-align: center;
      }

      strong {
        color: #000000;
        font-weight: bold;
        line-height: 18px;
        text-align: left;
      }
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: auto;
    place-self: center;
    place-items: center;
    place-content: center;
    height: auto;
  }
`;

export const InfoCard = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  place-content: space-between;
  column-gap: 45px;
  row-gap: 23px;

  p {
    margin: 0 !important;
  }

  @media (max-width: 768px) {
    grid-template-columns: auto;
    place-self: center;
    place-items: center;
    place-content: center;
    height: auto;

    p {
      display: flex;
      flex-direction: column;
      place-content: center;
      place-items: center;
      text-align: center;
    }
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  button {
    width: 160px;

    &:first-child {
      margin-right: 16px;
      width: 130px;
    }
  }
`;

export const ModalStyle = styled(Modal)`
  .modal-content {
    max-width: 648px;
    width: auto;
    border-radius: 10px;
  }
  .modal-dialog-centered {
    max-width: 648px !important;
    place-content: center;
  }
`;

export const Header = styled.header`
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Error = styled.span`
  color: #dc3545;
`;

export const ReCAPTCHAContainer = styled.div`
  display: flex;
  place-content: center;
  place-items: center;
  place-self: center;
  margin-bottom: 20px;
`;
